import { render, staticRenderFns } from "./QueryBuilderChild.vue?vue&type=template&id=0985327d&scoped=true&"
import script from "./QueryBuilderChild.vue?vue&type=script&lang=ts&"
export * from "./QueryBuilderChild.vue?vue&type=script&lang=ts&"
import style0 from "./QueryBuilderChild.vue?vue&type=style&index=0&id=0985327d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0985327d",
  null
  
)

export default component.exports